"use client"

import { Input } from "antd";
import { PasswordProps } from "antd/es/input";
import { FC } from "react";

const InputPassword: FC<PasswordProps> = (props) => {
  return (
    <Input.Password {...props} />
  )
}

InputPassword.displayName = 'InputPassword'

export default InputPassword